var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ag-input',{ref:"input",staticClass:"input",attrs:{"id":_vm.id,"value":_vm.value,"disabled":_vm.disabled,"readonly":_vm.readonly,"max-length":_vm.maxLength,"autocomplete":"off"},on:{"change":_vm.onChange}})}
var staticRenderFns = []

export { render, staticRenderFns }